const productionApiBaseUrl = "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/";
const configured = process.env.API_BASE_URL || (process.env.NODE_ENV === "production" ? productionApiBaseUrl : "http://localhost:3001/");
const baseUrl = configured.endsWith("/") ? configured : `${configured}/`;
export default baseUrl;
